import { render, staticRenderFns } from "./Startseite3.vue?vue&type=template&id=29a98be8&scoped=true&"
import script from "./Startseite3.vue?vue&type=script&lang=js&"
export * from "./Startseite3.vue?vue&type=script&lang=js&"
import style0 from "./Startseite3.vue?vue&type=style&index=0&id=29a98be8&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a98be8",
  null
  
)

export default component.exports